module.exports = __webpack_public_path__ + "img/breed-chicken-banner.7bee92ab.svg";